jQuery(document).ready(function($){
    
    $(".hamburger").click(function(){
        $(this).toggleClass("is-active"); 
    
        
        $(".nav_overlay, .header-bar .logo").toggleClass("on");
        
        $("body").toggleClass("nav_open");
    });
    
    
    
    if($("body").hasClass("home")){
        console.log("home");
        $(".scrolldown").on('click', function(event) {
    
            if (this.hash !== "") {
           
              event.preventDefault();
        
            
              var hash = this.hash;
        
              $('html, body').animate({
                scrollTop: $(hash).offset().top
              }, 400, function(){
        
        
                window.location.hash = hash;
              });
            } 
        });
        
        
        
        var controller = new ScrollMagic.Controller({vertical: true});
        
        
        
        var heroLogoM = TweenMax.to(".hero_logo #m-mask", 0.8, {strokeDashoffset: 0, delay: 0.6, ease: Sine.easeInOut});
        
        var heroLogoSpace = TweenMax.to(".hero_logo #space-mask", 0.8, {strokeDashoffset: 414, delay: 0.6, ease: Sine.easeInOut});
        
        var welcome = TweenMax.to(".hero_content h2", 0.8, {opacity: 1, delay: 0.6, ease: Sine.easeInOut});
        
        /*var hero = new ScrollMagic.Scene({duration: 500}) //matches duration of following scenes
        			.triggerHook(0)
        			.setPin("section.hero")
        			//.addIndicators({name: "hero"}) // add indicators (requires plugin)
        			.addTo(controller);*/
        
        
        /*var heroLogoScroll = new ScrollMagic.Scene({duration: 300})
        			.setTween(".intro_copy", {opacity:0})
    				//.addIndicators({name: "intro copy"}) 
    				.addTo(controller);*/
    	var fadeoutWelcome = TweenMax.to(".intro_copy", 0.8, {opacity: 0, delay: 3, ease: Sine.easeInOut});			
        
    				
        /*var heroHeadline = new ScrollMagic.Scene({duration: 300, offset:250})
        			.setTween(".hero_content h1", {opacity:1, y:0})
    				//.addIndicators({name: "h1"}) 
    				.addTo(controller);*/
    	var heroHeadline = TweenMax.to(".hero_content h1", 0.8, {opacity: 1, y:0, delay: 3.2, ease: Sine.easeInOut});			
        
        /*var heroGreenBar = new ScrollMagic.Scene({duration: 300, offset: 250})
        			.setTween(".hero_content .green_bar", {opacity: 1})
    				//.addIndicators({name: "green_bar"}) 
    				.addTo(controller);*/
        var heroGreenBar = TweenMax.to(".hero_content .green_bar", 0.8, {opacity: 1, y:0, delay: 3.2, ease: Sine.easeInOut});
                    
                    
        /*var heroGreenBarText = new ScrollMagic.Scene({duration: 300, offset: 500})
        			.setTween(".hero_content .green_bar_content", {opacity: 1, y: 0})
    				.addIndicators({name: "green_bar_content"}) 
    				.addTo(controller);*/
    				   
        
        var headerBar = new ScrollMagic.Scene({offset: $(".home .hero").height() - 124})
        			//.setTween(".header-bar", 0.4, {backgroundColor: "#373a36"})
    				//.addIndicators({name: "header-bar"}) 
    				.addTo(controller); 
                    
        headerBar.on("enter leave", function (event) {
            $(".home .header-bar").toggleClass("dark");
        }); 
        
    
    
    
        ///Homepage Content
        /*
        var rotating_headline = new ScrollMagic.Scene({triggerElement: "section.intro", duration: 300}) 
                    .triggerHook(0.9)
        			.setTween(".rotating_headline", {opacity: 1, scale:1})
    				//.addIndicators({name: "rotating_headline"}) 
    				.addTo(controller);            
        
        var intro_copy = new ScrollMagic.Scene({triggerElement: "section.intro p", duration: 300}) 
                    .triggerHook(0.9)
        			.setTween(".intro p", {opacity: 1})
    				//.addIndicators({name: "intro copy"}) 
    				.addTo(controller);
    
        
        
        var servicesTimeline = new TimelineMax({ paused: true });
        
        servicesTimeline.staggerTo(".services .service_wrap", 1.5, {scale:1, opacity:1, ease: CustomEase.create("custom", "M0,0 C0,0 0.049,0.584 0.085,1.024 0.122,1.407 0.264,1.27 0.302,1.188 0.338,1.07 0.411,0.956 0.47,0.956 0.579,0.956 0.667,0.984 0.725,0.99 0.83,1 1,1 1,1")}, 0.1);            
    
                    
        var services = new ScrollMagic.Scene({triggerElement: ".service_wrap"}) 
                    .triggerHook(0.6)
    				//.addIndicators({name: "services"}) 
    				.addTo(controller)
    				.on("enter", function(event){
        				servicesTimeline.play();
        				console.log("test");
    				});
    
        */
        
        
        
    
        const players = Plyr.setup('.case_study .case_study_video', {
            iconURL: "../images/plyr.svg",
            controls: ['play', 'mute', 'volume', 'fullscreen'],
            fullscreen: { enabled: true, fallback: true, iosNative: true },
            loop: {active: true},
            //muted: true,
            autoplay: false
        });
    
        
        
        var casestudy1 = new ScrollMagic.Scene({triggerElement: ".case_study1", duration: $('.case_study1').height()})
        			//.addIndicators() // add indicators (requires plugin)
        			.addTo(controller);
        			
        /*var casestudy2 = new ScrollMagic.Scene({triggerElement: ".case_study2", duration: $('.case_study2').height()})
        			//.addIndicators() // add indicators (requires plugin)
        			.addTo(controller);*/
    
        /*var casestudy3 = new ScrollMagic.Scene({triggerElement: ".case_study3", duration: $('.case_study3').height()})
        			//.addIndicators() // add indicators (requires plugin)
        			.addTo(controller);*/
    					
    	console.log(casestudy1.duration());
    					
        casestudy1.on("enter", function (event) {
            players[0].muted = true;
            players[0].hasAudio = true;
            
            var promise = players[0].play();
            
            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                }).catch(error => {
                    console.log("error: "+error);
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                });
            }
        });     
        
        /*casestudy2.on("enter", function (event) {
            players[1].muted = true;
            players[1].hasAudio = true;
            
            var promise = players[1].play();
            
            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                }).catch(error => {
                    console.log("error: "+error);
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                });
            }
        });    */   
        
        /*casestudy3.on("enter", function (event) {
            
            players[2].muted = true;
            players[2].hasAudio = true;
            
            var promise = players[2].play();
            
            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                }).catch(error => {
                    console.log("error: "+error);
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                });
            }
        });*/
        
        
        casestudy1.on("leave", function (event) {
            players[0].pause();
        });     
        
        /*casestudy2.on("leave", function (event) {
            players[1].pause();
        });*/    
        
        /*casestudy3.on("leave", function (event) {
            players[2].pause();
        });*/
        
        players[0].on("playing", function(){
            $(".case_study1 a.overlay_link").appendTo(".case_study1 .plyr");
        });
        
        /*players[1].on("playing", function(){
            $(".case_study2 a").appendTo(".case_study2 .plyr");
        });*/
        
        /*players[2].on("playing", function(){
            $(".case_study3 a").appendTo(".case_study3 .plyr");
        });*/
    
    
    }
    
    
    
    $('body').on('change', '#nf-field-8-0', function() {
        if( $(this).is(":checked") ){
            $("#nf-field-6-container").show(); 
            $("#nf-field-13-container").show();
            $("#nf-label-field-3").text("Tell us about your project. *");
        }
    });
    
    $('body').on('change', '#nf-field-8-1', function() {
        if( $(this).is(":checked") ){
            $("#nf-field-6-container").hide();
            $("#nf-field-13-container").hide(); 
            $("#nf-label-field-3").text("Message *");
        }
    });
    
    
    $(".filtering select").each(function(){
        var filter = $(this).data("filter");
        console.log(filter);
        
        var selected = $(this).val();
        console.log(selected);
        
        var text = $('.dropdown-pane [data-value="'+selected+'"]').text();
        console.log(text);
        
        if(selected){
            $('[data-toggle="'+filter+'"]').text(text);
        }
    });
    
    $(".filtering .dropdown-pane li").on("click", function(){
       var selectedName = $(this).text();
       var selectedSlug = $(this).data('value');
       var dropdownID = $(this).parents(".dropdown-pane").attr('id');
       console.log(selectedName);
       console.log(dropdownID);
       console.log(selectedSlug);
       $('[data-toggle="'+dropdownID+'"]').text(selectedName);
       
       
       $('[data-filter="'+dropdownID+'"]').val(selectedSlug).change();
       
       $(".dropdown-pane").foundation('close'); 
       
    });
    
    
    $("body").on("click",function(){
        $(".dropdown-pane").foundation('close');
    });
    
    /*
    $(".filtering select").on('change',function(){
        if($("select[name='client']").val() === "" && $("select[name='type']").val() === "") {
             $(".filtering button.submit").attr("disabled","disabled");
             $(".filtering button.reset").attr("disabled","disabled");
             console.log("no values");
        } else {
            $(".filtering button.submit").removeAttr("disabled");
            $(".filtering button.reset").removeAttr("disabled");
            console.log("values");
        }
        
        $("form.filtering").submit();
       
    });
    
    $(".filtering .reset").on("click", function(){
        console.log('reset');
        $(".filtering select").prop('selectedIndex',0);
        
        $('[data-toggle="client-dropdown"]').text("Filter by Client");
        $('[data-toggle="type-dropdown"]').text("Filter by Type");
        
        $(".filtering button.submit").attr("disabled","disabled");
        $(".filtering button.reset").attr("disabled","disabled");
    });
    
    
    if($("select[name='client']").val() != "" || $("select[name='type']").val() != ""){
        console.log("hello");
        $(".filtering button.submit").removeAttr("disabled");
        $(".filtering button.reset").removeAttr("disabled");
    }
*/
    
    
    
    var $packeryGrid = $('.packery-grid').packery({
      // options
      itemSelector: '.grid-item',
      gutter: 10,
      percentPosition: true
    });
    
    $packeryGrid.imagesLoaded().progress( function() {
      $packeryGrid.packery();
    });
    
    
    const players = Plyr.setup('.wp-block-embed-youtube .responsive-embed', {
        iconURL: "../images/plyr.svg",
        controls: ['play', 'mute', 'volume', 'progress'],
        loop: {active: true},
        //muted: true,
        autoplay: false
    });
			
			
					
});